import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'react-jss';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const withThemeFromProps = (WrappedComponent) => {
  const HoC = props => (
    <ThemeProvider theme={props.theme}>
      <WrappedComponent {..._.omit(props, 'theme')} />
    </ThemeProvider>
  );

  HoC.propTypes = {
    theme: PropTypes.shape({}).isRequired,
  };
  HoC.displayName = `WithThemeFromProps(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
